module.exports = __webpack_public_path__ + "static/media/triangle_down.e43d6adc.svg";